import VehicleGuide from "../../components/Vehicle/VehicleGuide";

function VehicleGuideMain() {
  return (
    <>
      <VehicleGuide />
    </>
  );
}

export default VehicleGuideMain;
